var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInductionStoveOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7601 32.0387H53.0158V29.4334H54.4662C56.0522 29.4334 57.3399 28.1429 57.3399 26.5597C57.3399 24.9737 56.0494 23.686 54.4662 23.686L7.10987 23.6833C6.33992 23.6833 5.61341 23.9842 5.07116 24.5319C4.52895 25.0795 4.23076 25.806 4.23618 26.576C4.24702 28.1511 5.53748 29.4307 7.10987 29.4307H8.0262V32.0361L3.27918 32.0388C1.75558 32.0388 0.516602 33.2777 0.516602 34.8013C0.516602 36.3249 1.75558 37.5639 3.27918 37.5639H8.02349V42.254C8.02349 49.0859 13.5811 54.6459 20.4154 54.6459H40.6178C47.4524 54.6459 53.0097 49.0883 53.0097 42.254V37.5639H57.754C59.2776 37.5639 60.5166 36.3249 60.5166 34.8013C60.5193 33.2805 59.2831 32.0388 57.7594 32.0388L57.7601 32.0387ZM6.40203 26.5651C6.40203 26.3753 6.47252 26.1964 6.60807 26.0636C6.74092 25.928 6.91985 25.8548 7.10962 25.8548H54.4659C54.8563 25.8548 55.1708 26.172 55.1708 26.5597C55.1708 26.9501 54.8536 27.2645 54.4659 27.2645H51.9311L9.1103 27.2672H7.10955C6.72187 27.2645 6.4047 26.95 6.40199 26.5651L6.40203 26.5651ZM3.2789 35.398C2.95086 35.398 2.68518 35.1323 2.68518 34.8043C2.68518 34.4762 2.95086 34.2106 3.2789 34.2106H8.02321V35.398L3.2789 35.398ZM50.8441 42.2569C50.8441 47.8932 46.257 52.48 40.6211 52.48H20.4186C14.7824 52.48 10.1956 47.8929 10.1956 42.2569V29.4362H50.8448L50.8441 42.2569ZM57.76 35.398H53.0157V34.2106H57.76C58.088 34.2106 58.3537 34.4763 58.3537 34.8043C58.3537 35.1296 58.0853 35.398 57.76 35.398V35.398Z",
    fill: "url(#paint0_linear_34666_9986)",
    stroke: "url(#paint1_linear_34666_9986)",
    strokeWidth: 0.668226
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.52 22.1703C31.1191 22.1703 31.6044 21.685 31.6044 21.0859V7.27058C31.6044 6.67144 31.1191 6.18616 30.52 6.18616C29.9208 6.18616 29.4355 6.67144 29.4355 7.27058V21.0859C29.4355 21.685 29.9208 22.1703 30.52 22.1703Z",
    fill: "url(#paint2_linear_34666_9986)",
    stroke: "url(#paint3_linear_34666_9986)",
    strokeWidth: 0.668226
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0971 22.1704C25.6963 22.1704 26.1815 21.6851 26.1815 21.0859V10.2744C26.1815 9.67522 25.6963 9.18994 25.0971 9.18994C24.498 9.18994 24.0127 9.67522 24.0127 10.2744V21.0859C24.0127 21.6851 24.498 22.1704 25.0971 22.1704Z",
    fill: "url(#paint4_linear_34666_9986)",
    stroke: "url(#paint5_linear_34666_9986)",
    strokeWidth: 0.668226
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9428 22.1704C36.542 22.1704 37.0272 21.6851 37.0272 21.0859V10.2744C37.0272 9.67522 36.542 9.18994 35.9428 9.18994C35.3437 9.18994 34.8584 9.67522 34.8584 10.2744V21.0859C34.8584 21.6851 35.3437 22.1704 35.9428 22.1704Z",
    fill: "url(#paint6_linear_34666_9986)",
    stroke: "url(#paint7_linear_34666_9986)",
    strokeWidth: 0.668226
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34666_9986",
    x1: 44.9995,
    y1: 31.6544,
    x2: 24.3419,
    y2: 82.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34666_9986",
    x1: 44.9995,
    y1: 31.6544,
    x2: 24.3419,
    y2: 82.6779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34666_9986",
    x1: 31.0435,
    y1: 10.3011,
    x2: 25.8953,
    y2: 11.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34666_9986",
    x1: 31.0435,
    y1: 10.3011,
    x2: 25.8953,
    y2: 11.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34666_9986",
    x1: 25.6206,
    y1: 12.5316,
    x2: 20.5485,
    y2: 13.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34666_9986",
    x1: 25.6206,
    y1: 12.5316,
    x2: 20.5485,
    y2: 13.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34666_9986",
    x1: 36.4663,
    y1: 12.5316,
    x2: 31.3942,
    y2: 13.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34666_9986",
    x1: 36.4663,
    y1: 12.5316,
    x2: 31.3942,
    y2: 13.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInductionStoveOrangeIcon);
export default __webpack_public_path__ + "static/media/induction_stove_orange_icon.d68cddbd265724d96f3a797ee3d76424.svg";
export { ForwardRef as ReactComponent };